import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { Text } from '@reveni-io/reveni-ui'

import { displayOptions } from './constants'
import { getTooltipText } from './helpers'
import * as Styles from './styles'

const ChartDisplayToggle = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      {displayOptions.map(option => (
        <Tooltip key={option.key} title={getTooltipText(t, option.tooltipKey)} position="bottom" trigger="mouseenter">
          <Styles.Button isActive={value === option.key} onClick={() => onChange(option.key)}>
            <Text type="bodySBold">{option.label}</Text>
          </Styles.Button>
        </Tooltip>
      ))}
    </Styles.Container>
  )
}

export default ChartDisplayToggle
